import SeatTrade from './SeatTrade'

export default SeatTrade
